/*
 * @Author: 吴文洁
 * @LastEditors  : 吴文洁
 * @Description: 
 * @Date: 2019-05-13 10:39:51
 * @LastEditTime : 2020-01-10 18:16:47
 */
import isEmojiCharacter from '@/common/utils/isEmojiCharacter';
export default function VaidateCondition() {

  const validateCondition: {
    [index: string]: Function
  } = {
    // 增加正则判断
    'isRegRight': function (value: any, errMsg: string, min: number, max: number, limit: number, regExp: any) {
      if (!regExp.exec(value)) {
        return errMsg;
      }
    },

    // 判断值是否为空
    'isNonEmpty': function (value: any, errMsg: string): string | void {
      if (!value) {
        return errMsg;
      }
    },
    
    // 判断是否含有emoji
    'isEmoji': function(value: any, errMsg: string): string | void {
      if(isEmojiCharacter(value)) {
        return errMsg;
      }
    },

    // 必须大于等于某个值
    'minLimit': function (
      value: any,
      errMsg: string,
      min: number,
      max: number,
      limit: number
    ): string | void {
      if (value < limit) {
        return errMsg;
      }
    },

    // 等于某个值提示
    'isEqualLimit': function (
      value: any,
      errMsg: string,
      min: number,
      max: number,
      limit: number
    ): string | void {
      if (value === limit) {
        return errMsg;
      }
    },



    // 不得大于某个值
    'isLessThen': function (
      value: number,
      errMsg: string,
      min: number,
      max: number,
      limit: number
    ): string | void {
      if (value > limit) {
        return errMsg;
      }
    },

    'isCustomizeEmpty': function (list: any) {
      for (let index = 0; index < list.length; index++) {
        if (!list[index].value && list[index].isOpen) {
          if (list[index].type == 'text') {
            return `请输入${list[index].key}`;
          } else {
            return `请选择${list[index].key}`;
          }
        }
      }
    },

    // 判断是否含有特殊字符
    'haSpecialChar': function (value: string, errMsg: string): string | void {
      const regx: RegExp = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/;
      if (regx.test(value)) {
        return errMsg;
      }
    },

    // 判断手机号是否正确
    'isPhoneRight': function (value: string, errMsg: string): string | void {
      const regx: RegExp = /^\d{11}$/;
      if (!regx.test(value)) {
        return errMsg;
      }
    },

    // 判断截止时间是否正确
    'isDeadlineRight': function (value: number, errMsg: string): string | void {
      if (value <= new Date().valueOf()) {
        return errMsg;
      }
    },

    // 判断开始时间是否正确
    'isStartTimeRight': function (start: number, end: number, errMsg: string): string | void {
      if (start > end) {
        return errMsg;
      }
    },

    // 结果不能为负数
    'isNonNegative': function (value: number, errMsg: string): string | void {
      if (value < 0) {
        return errMsg;
      }
    },

    // 结果是否在某个区间内
    'isIntervalRight': function (
      value: number,
      errMsg: string,
      min: number,
      max: number
    ): string | void {
      if (value < min || value > max) {
        return errMsg
      }
    },

    // 是否为整数
    'isInteger': function (value: number, errMsg: string): string | void {
      if (!Number.isInteger(value)) {
        return errMsg;
      }
    },

    // 提示
    'isAlert': function (value: string, errMsg: string): string | void {
      return errMsg;
    },

    add: function (condition: string, fn: Function) {
      this[condition] = fn;
    }
  }
  return validateCondition;
}